import { z } from 'zod';
import { HttpErrorResponse } from '../../common/validation-error';
import { CmsProjectDefinitionSchema } from './applied-project';
export const CmsProjectListItemSchema = z.object({
    name: z.string(),
    slug: z.string(),
    topic: z.string(),
    questionsCount: z.number(),
    publishStatus: z.enum(['LIVE', 'ARCHIVED']),
    isProsumer: z.boolean(),
    updatedAt: z.string(),
});
export const GetCmsProjectParams = z.object({
    slug: z.string().min(1),
});
export const getCmsProjectsRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/cms/projects',
    name: 'get-cms-projects',
    request: {},
    responses: { 200: z.array(CmsProjectListItemSchema) },
};
export const getCmsProjectRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/cms/projects/{slug}',
    name: 'get-cms-project',
    request: { params: GetCmsProjectParams },
    responses: {
        200: CmsProjectDefinitionSchema,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
